"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationInfo = void 0;
const Organization_1 = require("./Organization");
const Link_1 = require("./Link");
const OrganizationPage_1 = require("./OrganizationPage");
const EventDescription_1 = require("./EventDescription");
const ImageInfo_1 = require("./ImageInfo");
class OrganizationInfo {
    constructor(organization, links, pages, events, images, updated) {
        this.organization = organization;
        this.links = links;
        this.pages = pages;
        this.updated = updated;
        this.events = events;
        this.images = images;
    }
    static fromDashboardDto(dto) {
        return new OrganizationInfo(Organization_1.Organization.fromDto(dto.organization), dto.links ? dto.links.map(linkDto => Link_1.Link.fromDto(linkDto)) : [], dto.pages ? dto.pages.map(pageDto => OrganizationPage_1.OrganizationPage.fromDto(pageDto)) : [], [], dto.images ? dto.images.map(imageInfoDto => ImageInfo_1.ImageInfo.fromDto(imageInfoDto)) : [], dto.updated);
    }
    static fromClientDto(dto) {
        return new OrganizationInfo(Organization_1.Organization.fromDto(dto.organization), dto.links ? dto.links.map(linkDto => Link_1.Link.fromDto(linkDto)) : [], dto.pages ? dto.pages.map(pageDto => OrganizationPage_1.OrganizationPage.fromDto(pageDto)) : [], dto.events ? dto.events.map(descriptionDto => EventDescription_1.EventDescription.fromDto(descriptionDto)) : [], [], dto.updated);
    }
    toDto() {
        const resultDto = {
            organization: this.organization.toDto(),
            links: this.links.map(link => link.toDto()),
        };
        return resultDto;
    }
}
exports.OrganizationInfo = OrganizationInfo;
